import api from './api'
import AuthManager from '@/lib/AuthManager'

const emailAndPasswordSignIn = async (email, password) => {
  const { data } = await api.post('sessions/sign-in', { email, password })
  AuthManager.login(data.token)
  return data
}

const fetchCurrentUser = async () => {
  const { data } = await api.get('/account/current-user')
  return data
}

const signOut = async () => {
  await api.delete('/sessions/sign-out')
  AuthManager.logOff()
}

const sendEmailResetPassword = async email => {
  return await api.post('/sessions/password-reset/send-email', { email })
}

const resetPassword = async (email, password, token) => {
  return await api.post('/sessions/password-reset/reset', {
    email,
    password,
    token,
  })
}

export default {
  emailAndPasswordSignIn,
  fetchCurrentUser,
  signOut,
  resetPassword,
  sendEmailResetPassword,
}
